import styled from 'styled-components';

export const ClearButtonHolder = styled.div`
  align-self: center;
  padding-right: 20px;
`;
